import $ from 'jquery'
import template from 'lodash.template'
import AjaxList from '../../components/ajaxList'
import 'blueimp-file-upload-npm'
import { localeDate } from '../../utils/date'
import i18n from '../../utils/translate'

class Module {
  constructor ($module) {
    this.$container = $module.find('.js-tickets-container')
    this.$list = $module.find('.js-tickets_wrap')
    this.$templateEl = $module.find('.js-tickets-template')
    this.template = template(this.$templateEl.html())

    this.list = new AjaxList({
      $container: this.$container,
      $form: $module.find('.js-ticket-filter-form'),
      $load: $module.find('.js-tickets-load'),
      append: (response, replace) => {
        this.append(response, replace)
      }
    })
  }

  append (response, replace) {
    if (replace) {
      this.$list.empty()
    }

    if (!response.tickets.length) {
      this.$container.addClass('empty_list')
    } else {
      this.$container.removeClass('empty_list')

      const $content = $('<div>')

      response.tickets.forEach((v) => {
        $content.append(this.render(v))
      })

      this.$list.append($content)
    }
  }

  render (value) {
    const createdAt = localeDate(value.create_date)
    const updatedAt = localeDate(value.update_date)
    const url = this.$templateEl.data('ticket-url').replace(/0/, value.id)

    return this.template({
      id: value.id,
      url: url,
      statusClass: this.getStatusClass(value.status),
      statusName: this.getStatusName(value.status),
      idLabel: i18n.gettext('ticket.list.id', value.id, createdAt),
      title: value.title,
      createdAt: createdAt,
      updatedAt: updatedAt
    })
  }

  getStatusClass (status) {
    switch (status) {
      case 'working':
        return 'open'
      case 'pending':
        return 'wait'
    }

    return ''
  }

  getStatusName (status) {
    if (['closed', 'working', 'pending'].indexOf(status) === -1) {
      status = 'unknown'
    }

    return i18n.gettext('ticket.list.status_' + status)
  }
}

$(function () {
  $('.js-tickets-module').each(function () {
    new Module($(this))
  })
})
